import { render, staticRenderFns } from "./VideoIntro.vue?vue&type=template&id=28361201"
import script from "./VideoIntro.vue?vue&type=script&lang=js"
export * from "./VideoIntro.vue?vue&type=script&lang=js"
import style0 from "./VideoIntro.vue?vue&type=style&index=0&id=28361201&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports